import React from "react";
import Guidelines from "../components/GuideLines";

export default () => (
  <div className="pa3 pt5 w-60-l center pb6" style={{ minHeight: 400 }}>
    <Guidelines />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/applicationGudilnes.js